// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body .el-popover {\n  min-width: 0;\n}\nbody .custom-popper {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 5px 10px;\n  background: #E3E9F6;\n  color: #606266;\n  width: auto;\n  max-width: 300px;\n  box-sizing: border-box;\n}\nbody .custom-popper::-webkit-scrollbar {\n  width: 6px;\n  height: 13px;\n  border-radius: 6px;\n}", ""]);
// Exports
module.exports = exports;
